module.exports = __webpack_public_path__ + "img/ex3.d45f3fce.png";